"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotaoCard = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var arrow_right_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/arrow_right"));
var chevron_right_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_right"));
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var react_1 = __importDefault(require("react"));
var tags_ga_1 = require("../../utils/tags-ga");
var button_1 = require("../button");
var button_icon_1 = require("../button-icon");
var loading_1 = require("../loading");
var botao_card_styles_1 = require("./botao-card.styles");
/* Nos cards do detalhes da disciplina o botão do mobile e do desktop não estão padronizados
no desktop o botão é redondo e usa o ícone ArrowRight e no mobile é quadrado e usa o ícone ChevronRight
foi desenvolvido com o botão do Sava para manter o layout igual dos outros cards da mesma página
após a padronização dos botões/icones e a refatoração dos outros cards, utilizar o botão do Lift */
var BotaoCard = function (_a) {
    var tagsGa = _a.tagsGa, pendente = _a.pendente, ariaLabel = _a.ariaLabel, onClick = _a.onClick;
    var isMobile = (0, temas_frontend_1.useMobile)();
    var getIconeBotao = function (pendente, isMobile) {
        if (pendente)
            return react_1.default.createElement(loading_1.LoadingDefault, { width: "24px", height: "24px" });
        if (isMobile)
            return react_1.default.createElement(LftIconBase_1.default, { icon: chevron_right_1.default, size: 'sm' });
        return react_1.default.createElement(LftIconBase_1.default, { icon: arrow_right_1.default, size: 'md' });
    };
    if (isMobile) {
        return (react_1.default.createElement(tags_ga_1.TagsGa, { category: tagsGa === null || tagsGa === void 0 ? void 0 : tagsGa.category, action: tagsGa === null || tagsGa === void 0 ? void 0 : tagsGa.action, label: tagsGa === null || tagsGa === void 0 ? void 0 : tagsGa.label, eventType: "clique" },
            react_1.default.createElement(botao_card_styles_1.ButtonStyled, null,
                react_1.default.createElement(button_icon_1.ButtonIcon, { "data-testid": 'botao-card-mobile', primary: true, small: true, onClick: onClick, ariaLabel: ariaLabel, icon: getIconeBotao(pendente, isMobile), disabled: pendente }))));
    }
    return (react_1.default.createElement(button_1.Button, { "data-testid": 'botao-card-desktop', ariaLabel: ariaLabel, icon: getIconeBotao(pendente, isMobile), small: true, primary: true, onlyIcon: true, onClick: onClick, disabled: pendente, gaCategory: tagsGa === null || tagsGa === void 0 ? void 0 : tagsGa.category, gaAction: tagsGa === null || tagsGa === void 0 ? void 0 : tagsGa.action, gaLabel: tagsGa === null || tagsGa === void 0 ? void 0 : tagsGa.label, eventType: "clique" }));
};
exports.BotaoCard = BotaoCard;
